module.exports = __webpack_public_path__ + "static/media/HT.b269aba7.svg";